var map = {
	"./bialystok/podatek-rolny/section-1_pl.mdx": [
		20696,
		20696
	],
	"./bydgoszcz/podatek-rolny/section-1_pl.mdx": [
		59907,
		59907
	],
	"./czestochowa/podatek-rolny/section-1_pl.mdx": [
		77786,
		77786
	],
	"./garwolin/podatek-rolny/section-1_pl.mdx": [
		26781,
		26781
	],
	"./gdansk/podatek-rolny/section-1_pl.mdx": [
		15304,
		15304
	],
	"./gdynia/podatek-rolny/section-1_pl.mdx": [
		34312,
		34312
	],
	"./gliwice/podatek-rolny/section-1_pl.mdx": [
		15008,
		15008
	],
	"./gmina-swidnica/podatek-rolny/section-1_pl.mdx": [
		96073,
		96073
	],
	"./kielce/podatek-rolny/section-1_pl.mdx": [
		2551,
		2551
	],
	"./kolobrzeg/podatek-rolny/section-1_pl.mdx": [
		23669,
		23669
	],
	"./konskowola/podatek-rolny/section-1_pl.mdx": [
		3608,
		3608
	],
	"./koszalin/podatek-rolny/section-1_pl.mdx": [
		75103,
		75103
	],
	"./lask/podatek-rolny/section-1_pl.mdx": [
		32587,
		32587
	],
	"./lodz/podatek-rolny/section-1_pl.mdx": [
		76569,
		76569
	],
	"./lublin/podatek-rolny/section-1_pl.mdx": [
		90744,
		90744
	],
	"./miejsce-piastowe/podatek-rolny/section-1_pl.mdx": [
		42517,
		42517
	],
	"./mikolow/podatek-rolny/section-1_pl.mdx": [
		19528,
		19528
	],
	"./naklo/podatek-rolny/section-1_pl.mdx": [
		90877,
		90877
	],
	"./oborniki/podatek-rolny/section-1_pl.mdx": [
		34687,
		34687
	],
	"./olesnica/podatek-rolny/section-1_pl.mdx": [
		35488,
		35488
	],
	"./postomino/podatek-rolny/section-1_pl.mdx": [
		99724,
		99724
	],
	"./poznan/podatek-rolny/section-1_pl.mdx": [
		71700,
		71700
	],
	"./przechlewo/podatek-rolny/section-1_pl.mdx": [
		89247,
		89247
	],
	"./radom/podatek-rolny/section-1_pl.mdx": [
		125,
		125
	],
	"./raszkow/podatek-rolny/section-1_pl.mdx": [
		16617,
		16617
	],
	"./rawicz/podatek-rolny/section-1_pl.mdx": [
		56689,
		79070
	],
	"./ryman/podatek-rolny/section-1_pl.mdx": [
		20833,
		20833
	],
	"./sierakowice/podatek-rolny/section-1_pl.mdx": [
		69114,
		69114
	],
	"./slawno/podatek-rolny/section-1_pl.mdx": [
		65746,
		65746
	],
	"./slawoborze/podatek-rolny/section-1_pl.mdx": [
		11412,
		11412
	],
	"./stare-babice/podatek-rolny/section-1_pl.mdx": [
		73412,
		73412
	],
	"./szczecin/podatek-rolny/section-1_pl.mdx": [
		80585,
		80585
	],
	"./szemud/podatek-rolny/section-1_pl.mdx": [
		86396,
		86396
	],
	"./warszawa/podatek-rolny/section-1_pl.mdx": [
		29224,
		29224
	],
	"./wloszczowa/podatek-rolny/section-1_pl.mdx": [
		93987,
		16368
	],
	"./wroclaw/podatek-rolny/section-1_pl.mdx": [
		94627,
		94627
	],
	"./wyszkow/podatek-rolny/section-1_pl.mdx": [
		76134,
		76134
	],
	"./zukowo/podatek-rolny/section-1_pl.mdx": [
		14799,
		14799
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 33455;
module.exports = webpackAsyncContext;